import React from 'react';
import PropTypes from 'prop-types';

import Progress from '../progress/progress';

import './title-pagination.scss';

const TitlePagination = (props) => {
	const {
		paginations,
		progressDelay,
		progressSpeed,
	} = props;

	return (
		<div className="slider-title-pager__inner">
			{paginations.map((pagination) => {
				return (
					<div
						key={pagination.id}
						role="presentation"
						className={`slider-title-pager__item${pagination.active ? ' is-active' : ''}`}
						onClick={() => {
							if (pagination.onClick) pagination.onClick(pagination.id);
						}}
					>
						<span className="slider-title-pager__text">{pagination.title}</span>

						<Progress
							active={pagination.active}
							delay={progressDelay}
							speed={progressSpeed}
						/>
					</div>
				);
			})}
		</div>
	);
};

TitlePagination.defaultProps = {
	paginations: [],
	progressDelay: 0,
	progressSpeed: 3000,
};

TitlePagination.propTypes = {
	paginations: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		title: PropTypes.string.isRequired,
		active: PropTypes.bool,
		onClick: PropTypes.func,
	})),
	progressDelay: PropTypes.number,
	progressSpeed: PropTypes.number,
};

export default TitlePagination;
